export default "__VITE_ASSET__B8z1EK6m__"